module.exports = window.__babel_polyfill__;


//////////////////
// WEBPACK FOOTER
// external "window.__babel_polyfill__"
// module id = 1
// module chunks = 8